import React, {useState} from 'react';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import {API_URL} from '../../constants';

const getErrorMessage = (error) => {
    if (error?.response?.data?.errors) {
        return Object.values(error.response.data.errors).flat().join(' ');
    }

    return error?.response?.data?.message || 'An error occurred. Please try again later.';
};

const VehicleDeleteAction = ({
    vehicleId,
    token,
    disabled = false,
    onDeleted,
    onError,
    onUnauthorized,
}) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = async () => {
        if (!window.confirm(
            `Permanently delete vehicle #${vehicleId}? This action cannot be undone.`
        )) return;

        setIsDeleting(true);
        onError('');

        try {
            const response = await axios.delete(`${API_URL}/api/admin/vehicles/${vehicleId}`, {
                headers: {'Authorization': `Bearer ${token}`},
            });
            onDeleted(response.data?.message || 'Vehicle deleted successfully');
        } catch (error) {
            if (error?.response?.status === 401) {
                onUnauthorized();
                return;
            }

            onError(getErrorMessage(error));
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <button
            className="btn btn-danger ml-2"
            type="button"
            onClick={handleDelete}
            disabled={disabled || isDeleting}
        >
            {isDeleting
                ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />&nbsp;Deleting...</>
                : 'Delete Vehicle'
            }
        </button>
    );
};

export default VehicleDeleteAction;
